import React from 'react';
import {Icon} from '@iconify/react';
import {IoIosSettings,  IoMdHome} from 'react-icons/io';
import { MdSupervisedUserCircle} from 'react-icons/md';
import {FaStoreAlt} from 'react-icons/fa';

const sidebarConfig = [
  {
    title: 'Home',
    path: '/dashboard/home',
    icon: <IoMdHome size={20} />,
    roles: ['student',"teacher","guest"],
    
  },
  {
    title: 'My Courses',
    path: '../dashboard/my-courses',
    icon: <Icon icon='mdi:account-group' width='20' height='20' />,
    roles: ['student',"guest"],
  },
  {
    title: 'Mock Test',
    path: '../dashboard/mock-test',
    icon: <Icon icon='mdi:book-open-page-variant' width='20' height='20' />,
    roles: ['student',],
    
  },
  {
    title: 'My Training',
    path: '../dashboard/my-training',
    icon: <Icon icon='mdi:book-open-page-variant' width='20' height='20' />,
    roles: ["teacher"],
    
  },

  {
    title: 'Counsellor',
    path: '/dashboard/counsellor',
    icon: <MdSupervisedUserCircle size={20} />,
    roles: ['student',"guest"],
  },
  {
    title: 'Events',
    path: '/dashboard/events',
    icon: <FaStoreAlt size={18} />,
    roles: ['student',"teacher","guest"],
  },

  {
    title: 'Settings',
    path: '/dashboard/settings',
    icon: <IoIosSettings size={20} />,
    roles: ['student',"teacher","guest"],
  },
  {
    title: 'Support',
    path: '/dashboard/support',
    icon: <Icon icon='mdi:help-circle' width='20' height='20' />,
    roles: ['student',"teacher","guest"],
   
  },
];

export default sidebarConfig;
